import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  hiddenOnDesktop: {
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
      visibility: 'hidden',
    },
  },
  hiddenOnMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
      visibility: 'hidden',
    },
  },
}));

export default useStyles;
